class FaqsExplore {
    constructor(selector) {
        this.container = document.querySelector(selector);
        if (!this.container) return;

        this.headers = this.container.querySelectorAll('h3');
        this.init();
        }

        init() {
        this.headers.forEach((h3) => {
            h3.addEventListener('click', () => this.toggleActive(h3));
        });
    }

    toggleActive(h3) {
        const next = h3.nextElementSibling;

        document.querySelectorAll('h3.active, h3 + * .active, h3 + *.active').forEach(el => {
            el.classList.remove('active');
        });

        if (next && next.tagName.toLowerCase() !== 'h3') {
            h3.classList.toggle('active');
            next.classList.toggle('active');
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new FaqsExplore('.page-faqs .rte');
});
